import * as http from 'utils/http';
import config from 'config';

const bulkHandlerAssignment = async ({ agent, ids }) => {
  const staffUsers = await http.put(`${config.API_URL}mercury/journeys/bulk_update/handler`, {
    handler_id: agent,
    journey_ids: ids,
  });
  return staffUsers;
};

export { bulkHandlerAssignment };
